<template>
  <div class="block-sidebar-box" >
    <dl>
      <dt @click="openPage('/support/service?type=1')" v-if="deviceType == 'pc'">
        <!-- <i class="iconfont icon-kefu block-sidebar-ico"></i> -->
        <div class="block-sidebar-ico">
          <img :src="require('@/assets/images/help-desk.png')">
        </div>
        <span class="block-sidebar-title">在线客服</span>
        <div class="view hide-cont">
          <p>在线沟通，获取专业解决方案</p>
        </div>
      </dt>
      <dd v-if="deviceType == 'pc'">
        <!-- <i class="iconfont icon-dianhua1 block-sidebar-ico"></i> -->
        <div class="block-sidebar-ico">
          <img :src="require('@/assets/images/icon-05.png')">
        </div>
        <span class="block-sidebar-title">客服热线</span>
        <div class="view">
         <img :src="require('@/assets/images/phone.gif')">
        </div>
      </dd>
      <dd v-if="deviceType == 'pc'">
        <!-- <i class="iconfont icon-weixin block-sidebar-ico"></i> -->
        <div class="block-sidebar-ico">
          <img :src="require('@/assets/images/icon-06.png')">
        </div>
        <span class="block-sidebar-title">公众号</span>
        <div class="view">
          <img :src="require('@/assets/images/ewm.jpg')">
        </div>
      </dd>
      <dd v-if="deviceType == 'pc'" @click="openCloud()">
        <div class="block-sidebar-ico">
          <img :src="require('@/assets/images/icon-07.png')">
        </div>
        <span class="block-sidebar-title">预约体验</span>
      </dd>
      <dd @click="toTop" v-show="scrollTop">
        <!-- <i class="iconfont icon-fanhuidingbu block-sidebar-ico"></i> -->
        <div class="block-sidebar-ico">
          <img :src="require('@/assets/images/icon-08.png')">
        </div>
        <span class="block-sidebar-title">返回顶部</span>
      </dd>
    </dl>
    <loginModal ref="loginModal" @ok="loginOk" />
  </div>
</template>
<script>
import loginModal from '@/components/login-modal'
export default {
  components: {  loginModal },
  data() {
    return {
      showActiveTop: false,
      scrollTop:0
    }
  },
  mounted() { },
  
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
    token() {
      return this.$store.state.login.token
    },
  },
  methods: {
    openUrl(url) {
      window.open( url, '_blank');
    },
    openPage(path) {
      this.$router.push({ path})
    },
    openCloud() {
      if (!this.token) {
        this.$refs.loginModal.showModal()
      } else {
        this.$router.push({ path:'/support/service?type=4'})
      }
    },
    loginOk() {
      this.$router.push({ path:'/support/service?type=4'})
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
  }
}
</script>
